module.exports = __webpack_public_path__ + "static/media/slider-1.da083e8e.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/slider-1.jpg
// module id = 1187
// module chunks = 33